import { createNaturalMultiplicationTask, randInt, fullTensExplanation } from "./sharedNaturalMultiplication";

function pickData() {
  let a = randInt(12, 49);
  while (a % 10 === 0) a = randInt(12, 49);
  const b = randInt(2, 9) * 10;
  return { a, b, result: a * b };
}

const mod = createNaturalMultiplicationTask({
  type: "NaturalMulTwoDigitByFullTensTask",
  pickData,
  explain: fullTensExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
